
import { useState, useEffect } from 'react';

export default function AboutSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.getElementById('hakkimizda');
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  const stats = [
    { number: '10+', label: 'Tamamlanan Proje', icon: 'ri-file-check-line' },
    { number: '10+', label: 'Mutlu Müşteri', icon: 'ri-user-smile-line' },
    { number: '1+', label: 'Yıl Deneyim', icon: 'ri-time-line' },
    { number: '24/7', label: 'Destek Hizmeti', icon: 'ri-customer-service-2-line' }
  ];

  const features = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Yenilikçi Yaklaşım',
      description: 'En son teknolojileri kullanarak geleceğe yönelik çözümler geliştiriyoruz.'
    },
    {
      icon: 'ri-team-line',
      title: 'Uzman Ekip',
      description: 'Alanında deneyimli ve tutkulu profesyonellerden oluşan ekibimiz.'
    },
    {
      icon: 'ri-time-line',
      title: 'Zamanında Teslimat',
      description: 'Belirlenen sürelere uygun olarak projelerinizi eksiksiz teslim ediyoruz.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Sürekli Destek',
      description: 'Proje teslimi sonrasında da kesintisiz destek hizmeti sunuyoruz.'
    }
  ];

  return (
    <section id="hakkimizda" className="py-20 bg-gray-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-0 w-64 h-64 bg-cyan-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className={`transition-all duration-1000 transform ${
            isVisible ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'
          }`}>
            <div className="inline-flex items-center px-4 py-2 bg-blue-500/20 backdrop-blur-sm rounded-full border border-blue-400/30 mb-6">
              <i className="ri-information-line text-blue-400 mr-2"></i>
              <span className="text-blue-400 text-sm font-medium">Hakkımızda</span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
                Dijital Dönüşümde
              </span>
              <br />
              <span className="text-white">Güvenilir Ortağınız</span>
            </h2>

            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-8">
              AYYILDIZ DİGİTAL olarak, 2025 yılından bu yana işletmelerin dijital dönüşüm yolculuğunda yanlarında oluyoruz. 
              Kurucumuz <span className="text-blue-400 font-semibold">Gülistan AYYILDIZ</span> liderliğinde, modern teknolojiler ve yaratıcı tasarım anlayışıyla 
              her projeyi benzersiz kılmayı hedefliyoruz.
            </p>

            <p className="text-gray-300 mb-8 leading-relaxed">
              Ekibimiz, web tasarımı, geliştirme, mobil uygulama, e-ticaret ve dijital pazarlama 
              alanlarında uzmanlaşmış profesyonellerden oluşuyor. Her projede mükemmeliyeti 
              hedefliyor, müşterilerimizin başarısını kendi başarımız olarak görüyoruz.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-xl border border-gray-700/50 p-4 text-center hover:border-blue-500/50 transition-all duration-300"
                >
                  <div className="w-10 h-10 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className={`${stat.icon} text-blue-400 text-lg`}></i>
                  </div>
                  <div className="text-2xl font-bold text-white mb-1">{stat.number}</div>
                  <div className="text-gray-400 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content */}
          <div className={`transition-all duration-1000 delay-300 transform ${
            isVisible ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'
          }`}>
            {/* Company Image */}
            <div className="relative mb-8">
              <div className="relative h-80 rounded-2xl overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/4e415bca5ede0cf9e4c9d5f877157dca.jpg"
                  alt="AYYILDIZ DİGİTAL Ekibi"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent"></div>
              </div>
              
              {/* Floating Badge */}
              <div className="absolute -bottom-4 -right-4 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-2xl p-6 shadow-2xl">
                <div className="text-center">
                  <div className="text-2xl font-bold text-white mb-1">99%</div>
                  <div className="text-blue-100 text-sm">Müşteri Memnuniyeti</div>
                </div>
              </div>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-gray-800/30 to-gray-900/30 backdrop-blur-sm rounded-xl border border-gray-700/30 p-4 hover:border-blue-500/30 transition-all duration-300 group"
                >
                  <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center mb-3 group-hover:bg-blue-500/30 transition-colors duration-300">
                    <i className={`${feature.icon} text-blue-400 text-lg`}></i>
                  </div>
                  <h4 className="text-white font-semibold mb-2">{feature.title}</h4>
                  <p className="text-gray-400 text-sm leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
